/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMarsStrokeV = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m12 2 4.707 4.62-1.414 1.388L13 5.758v3.278l3 .001V11l-3-.001.001 1.284c2.282.455 3.999 2.436 3.999 4.81C17 19.802 14.761 22 12 22s-5-2.197-5-4.908c0-2.374 1.718-4.354 4-4.809v-1.284L8 11V9.037l3-.001V5.757L8.707 8.008 7.293 6.62zm0 12.148c-1.657 0-3 1.318-3 2.944s1.343 2.945 3 2.945 3-1.319 3-2.945-1.343-2.944-3-2.944z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgMarsStrokeV as MarsStrokeV };
